export default {
  "Expenses Report": "Rapport depenses",
  Expenses: "Depenses",
  "Add an expense": "Enrégistrer une dépense",
  Amount: "Montant",
  amount: "montant",
  Status: "Statut",
  status: "statut",
  Date: "Date",
  date: "date",
  Category: "Catégorie",
  category: "catégorie",
  "Reference ID": "ID de référence",
  Actions: "Actions",
  actions: "actions",
  "Create an expense": "Créer une dépense",
  "Expense category": "Catégorie de dépense",
  Account: "Compte",
  account: "compte",
  Description: "Description",
  description: "description",
  "Expense Details": "Détails de la dépense",
  "Transaction Details": "Détails de la transaction",
  User: "Utilisateur",
  user: "utilisateur",
  "Reference Id": "ID de référence",
  Created: "Créé",
  "All statuses": "Tous les statuts",
  "All Categories": "Toutes les catégories",
  "Start Date": "Date de début",
  "End date": "Date de fin",
  Search: "Rechercher",
  search: "rechercher",
  "Total Expenses": "Total des dépenses",
  "total expenses": "total des dépenses",
  "Top account": "Meilleur compte",
  "top account": "meilleur compte",
  "Top category": "Meilleure catégorie",
  "top category": "meilleure catégorie",
};
